import { getRegisterFunction } from '../../utils/register.js';
import { OneUxRadioGroupElement } from './OneUxRadioGroupElement.js';
export const register = getRegisterFunction(OneUxRadioGroupElement);
declare global {
  interface HTMLElementTagNameMap {
    'one-ux-radio-group': OneUxRadioGroupElement;
    "radio-group-1c1737a3049dac656238b34efc4e25d8": OneUxRadioGroupElement;
  }
}